import { Component, inject, input } from '@angular/core';

import { Loggable } from 'app/utils/logging/loggable';
import Social from 'entity/Social';
import User from 'entity/User';

import { VideoChatService } from '../../services/videochat.service';
@Component({
  selector: 'app-guest-admission',
  templateUrl: './guest-admission.component.html',
  styleUrls: ['./guest-admission.component.scss'],
  standalone: false,
})
export class GuestAdmissionComponent extends Loggable {
  private videoChatService = inject(VideoChatService);

  public readonly waitingUser = input<User>();
  public readonly social = input<Social>();

  public constructor() {
    super();
    this.setDisplayName('GuestAdmissionComponent');
  }

  private get socialId(): string | undefined {
    const { socialId } = this.social() ?? {};
    return socialId;
  }

  private get waitingUserId(): string | undefined {
    const { userId } = this.waitingUser() ?? {};
    return userId;
  }

  public async admitUser(): Promise<void> {
    if (!this.socialId) {
      this.error('Could not admit user, socialId is undefined');
      return;
    }

    if (!this.waitingUserId) {
      this.error('Could not admit user, waitingUserId is undefined');
      return;
    }
    await this.videoChatService.setAdmittedStatus(this.socialId, this.waitingUserId, true, false);
  }

  public async removeUser(): Promise<void> {
    if (!this.socialId) {
      this.error('Could not remove user, socialId is undefined');
      return;
    }
    if (!this.waitingUserId) {
      this.error('Could not remove user, waitingUserId is undefined');
      return;
    }
    await this.videoChatService.setAdmittedStatus(this.socialId, this.waitingUserId, false, true);
  }
}
